/* tslint:disable */

declare var Object: any;
export interface UserPasswordInterface {
  "userId": number;
  "password": string;
  "order": number;
  "id"?: number;
}

export class UserPassword implements UserPasswordInterface {
  "userId": number;
  "password": string;
  "order": number;
  "id": number;
  constructor(data?: UserPasswordInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UserPassword`.
   */
  public static getModelName() {
    return "UserPassword";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UserPassword for dynamic purposes.
  **/
  public static factory(data: UserPasswordInterface): UserPassword{
    return new UserPassword(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UserPassword',
      plural: 'UserPasswords',
      path: 'UserPasswords',
      idName: 'id',
      properties: {
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
        "order": {
          name: 'order',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
